import { forgotPassword } from './forgot-password.backend';
import { put } from 'redux-saga/effects';
import { forgotPasswordFail, forgotPasswordSuccess } from './actions';
import { makeErrorPayload } from '../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../shared/toast/redux/actions';

export function* forgotPasswordSaga(action) {
    const { email } = action.payload;
    try {
        yield forgotPassword(email);
        yield put(forgotPasswordSuccess());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(forgotPasswordFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
